import React, {Component} from "react";
import localization from "../../../config/localization";
import {
  Dialog,
  DialogTitle,
} from "@material-ui/core";
import Table from "./Table";
import FormController from "../Form/FormHandler";
import {AllViewContainer} from "../../../components/Letflow/ViewContainer";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";

class LiveStreams extends Component {
  state = {
    loaded: true,
    value: 'scheduled',
    showForm: false,
    create: '',
    livestreamId: '',
    refresh: false,
  }

  handleChange = (event, newValue) => {
    this.setState({value: newValue});
  };

  showCreateLiveStreamForm = () => {
    return (
      <FormController {...this.props} livestreamId={this.state.livestreamId} create={this.state.create} exitForm={() => this.setState({showForm: false, refresh: !this.state.refresh})}/>
    )
  }

  handleCloseDialog = () => {
    this.setState({showForm: false, create: false})
  }

  createDialog = () => (
    <Dialog
      open={this.state.showForm}
      onBackdropClick={this.handleCloseDialog}
      onEscapeKeyDown={this.handleCloseDialog}
      maxWidth='sm'
      fullWidth={true}
    >
      <DialogTitle>
        <span>
          {localization.get('livestreams')}
        </span>
      </DialogTitle>
      {this.showCreateLiveStreamForm()}
    </Dialog>
  );

  render() {
    return (
      <AllViewContainer onAdd={() => this.setState({showForm: true, create: true})} ref="viewContainer">
        <GridContainer>
          <GridItem xs={12}>
            {this.createDialog()}
            <Card>
              <CardBody>
                <Table value={this.state.value} refresh={this.state.refresh} onEdit={(livestreamId) => this.setState({showForm: true, create: false, livestreamId})}/>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </AllViewContainer>
    )
  }
}

export default LiveStreams;
